export enum SituacaoPedidoItem {
    EmCricao = 0,
    Criado = 1,
    Processado = 2,
    NaoProcessado = 3,
    AguardandoReprocessamento = 4,
    Desprovisionado = 5,
    ErroSistemico = 6
}
